export default {
	AUTH0_BASE_URL: "https://auth0.doenba.ai",
	AUTH0_AUDIENCE: "https://dooyeed.us.auth0.com/api/v2/",
	AUTH0_CLIENT_ID: "sJCXZWcsPJarfND9MdPlKVTd2mFy3FjC",
	AUTH0_SCOPE: "openid profile email read:current_user create:current_user_metadata update:current_user_metadata delete:current_user_metadata"
}